/* ===============================================================
Parallax JS - Optimized for Performance
=============================================================== */
class ParallaxJs {
    constructor() {
        this.elements = null;
        this.rafId = null;
        this.isActive = false;

        // Initialize only when needed
        if (document.querySelector('.irantheme-container-parallax-item')) {
            this.init();
        }
    }

    init() {
        this.elements = document.querySelectorAll(
            '.irantheme-container-parallax-item'
        );

        // Exit if no elements found
        if (this.elements.length === 0) return;

        this.setup();
    }

    setup() {
        // Initialize values
        this.x = 0;
        this.y = 0;
        this.targetX = 0;
        this.targetY = 0;
        this.friction = 0.05; // Slightly higher for smoother motion

        // Bind once
        this.handleMouseMove = this.handleMouseMove.bind(this);
        this.updateParallax = this.updateParallax.bind(this);

        this.addEvents();
        this.startAnimation();
    }

    addEvents() {
        // Use passive listeners for better scroll performance
        document.addEventListener('mousemove', this.handleMouseMove, {
            passive: true,
        });

        // Optional: Add scroll-based parallax
        // window.addEventListener('scroll', this.handleScroll, { passive: true });
    }

    handleMouseMove(e) {
        // Calculate once
        const centerX = window.innerWidth / 2;
        const centerY = window.innerHeight / 2;

        // Calculate normalized mouse position (-1 to 1)
        const mouseX = (centerX - e.clientX) / centerX;
        const mouseY = (centerY - e.clientY) / centerY;

        // Apply limits and calculate target
        this.targetX = Math.max(-20, Math.min(20, mouseX * 20));
        this.targetY = Math.max(-10, Math.min(10, mouseY * 10));
    }

    updateParallax() {
        // Use faster easing with delta time consideration
        this.x += (this.targetX - this.x) * this.friction;
        this.y += (this.targetY - this.y) * this.friction;

        // Only update if there's significant movement
        if (Math.abs(this.x) > 0.1 || Math.abs(this.y) > 0.1) {
            const transform = `translate(${this.x}px, ${this.y}px)`;

            // Use CSS transforms efficiently
            for (let i = 0; i < this.elements.length; i++) {
                this.elements[i].style.transform = transform;
            }
        }

        // Continue animation loop
        this.rafId = requestAnimationFrame(this.updateParallax);
    }

    startAnimation() {
        if (!this.rafId) {
            this.rafId = requestAnimationFrame(this.updateParallax);
            this.isActive = true;
        }
    }

    stopAnimation() {
        if (this.rafId) {
            cancelAnimationFrame(this.rafId);
            this.rafId = null;
            this.isActive = false;
        }
    }

    destroy() {
        this.stopAnimation();

        // Remove event listeners
        document.removeEventListener('mousemove', this.handleMouseMove);

        // Reset element styles
        if (this.elements) {
            for (let i = 0; i < this.elements.length; i++) {
                this.elements[i].style.transform = '';
            }
        }
    }
}

export default ParallaxJs;
